import { memo, useMemo } from 'react';
import { CheckCircle, XCircle, Clock } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../config/translations';

const StockBadge = memo(function StockBadge({ offers }) {
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  const stockStatus = useMemo(() => {
    if (!offers || offers.length === 0) {
      return { icon: Clock, color: 'text-gray-600', bgColor: 'bg-gray-100', text: t('unknown') || 'Unknown' };
    }

    const inStockCount = offers.filter(o => o.inStock !== false).length;
    const totalOffers = offers.length;

    if (inStockCount === 0) {
      return { icon: XCircle, color: 'text-red-600', bgColor: 'bg-red-100', text: t('outOfStock') || 'Out of Stock' };
    } else if (inStockCount === totalOffers) {
      return { icon: CheckCircle, color: 'text-green-600', bgColor: 'bg-green-100', text: t('inStock') || 'In Stock' };
    } else {
      return { icon: Clock, color: 'text-yellow-600', bgColor: 'bg-yellow-100', text: `${inStockCount}/${totalOffers} ${t('vendors') || 'vendors'}` };
    }
  }, [offers, language]);

  const StockIcon = stockStatus.icon;

  return (
    <span className={`inline-flex items-center space-x-1 px-2 py-1 rounded-full text-xs font-medium ${stockStatus.bgColor} ${stockStatus.color}`}>
      <StockIcon className="w-3 h-3" />
      <span>{stockStatus.text}</span>
    </span>
  );
});

export default StockBadge;
